module.exports = __webpack_public_path__ + "img/Step2.49b7769f.png";